import { CopyError } from '../copy/text.js';
import { viewerStrings } from '../copy/strings.js';
import { parseRules } from '@cdr-clarity/query-service';
import type { ClassificationRuleSet } from '@cdr-clarity/contracts';

export const rulesJsonBytes = 1024 * 1024;
export const rulesStorageKey = (platform: string): string => `cdr-clarity:rules:${platform}:v1`;

export function parseRulesJson(text: string): ClassificationRuleSet {
  if (new TextEncoder().encode(text).byteLength > rulesJsonBytes)
    throw new CopyError(
      viewerStrings.webStateRulesStorage.classificationRulesJSONExceedsTheMiBLimit,
    );
  return parseRules(JSON.parse(text));
}

export async function readRulesFile(file: Blob): Promise<ClassificationRuleSet> {
  if (file.size > rulesJsonBytes)
    throw new CopyError(
      viewerStrings.webStateRulesStorage.classificationRulesJSONExceedsTheMiBLimit2,
    );
  return parseRulesJson(new TextDecoder('utf-8', { fatal: true }).decode(await file.arrayBuffer()));
}

export function rulesJson(rules: ClassificationRuleSet): string {
  const text = JSON.stringify(parseRules(rules), null, 2);
  // Keep exported files within the same boundary as imported and saved files.
  parseRulesJson(text);
  return text;
}
